import { BrowserRouter, Route, Routes } from "react-router-dom";
import Tenthirty from "./pages/Tenthirty";
import Roof from "./pages/Roof";
import Lightning from "./pages/Lightning";
import Summer from "./pages/Summer";
import Noroom from "./pages/NoRoom";
import Dawn from "./pages/Dawn";
import Pink from "./pages/Pink";

import './assets/css/style.css';

// import React, { Component } from 'react';



function App() {

  // Mobile
  function setScreenSize() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`); //"--vh"라는 속성으로 정의해준다.
  }

  window.addEventListener('resize', () => setScreenSize());

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Tenthirty />} />
        <Route path="/ten-thirty/roof" element={<Roof />} />
        <Route path="/ten-thirty/lightning" element={<Lightning />} />
        <Route path="/ten-thirty/summer" element={<Summer />} />
        <Route path="/ten-thirty/noroom" element={<Noroom />} />
        <Route path="/ten-thirty/dawn" element={<Dawn />} />
        <Route path="/ten-thirty/pink" element={<Pink />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
